'use client';

import React from 'react';
import classnames from 'classnames';
import { useAtomValue } from 'jotai';
import styles from './HeroImages.module.scss';
import { theme, Theme } from '../../../store/theme';

function HeroImages() {
  const appTheme = useAtomValue<Theme>(theme);

  return (
    <div className={styles.hero__images}>
      <img
        className={classnames(styles.vector, styles.vector_blur_left, {
          [styles.hidden]: appTheme === Theme.LIGHT,
        })}
        src='/media/industry_hero_ellipse_left_dark.svg'
        alt='ellipse'
        loading='lazy'
      />
      <img
        className={classnames(styles.vector, styles.vector_blur_right, {
          [styles.hidden]: appTheme === Theme.LIGHT,
        })}
        src='/media/industry_hero_ellipse_right_dark.svg'
        alt='ellipse'
        loading='lazy'
      />
      <div className={styles.hero__images__overlay} />
      <img
        className={classnames(styles.vector, styles.vector_center)}
        src={`/media/industry_hero_center_${appTheme}.svg`}
        alt='vector'
        loading='lazy'
      />
      <img
        className={classnames(styles.vector, styles.vector_left)}
        src={`/media/industry_hero_left_${appTheme}.svg`}
        alt='vector'
        loading='lazy'
      />
      <img
        className={classnames(styles.vector, styles.vector_right)}
        src={`/media/industry_hero_right_${appTheme}.svg`}
        alt='vector'
        loading='lazy'
      />
    </div>
  );
}

export default HeroImages;
